export const TEST_IDS = {
  SITE_SELECTOR: 'site-selector',
  PLAN_SELECTOR: 'plan-selector',
  PLAN_SELECTOR_TOOLTIP: 'plan-selector-tooltip',
  SITE_SELECTOR_OPTIONS: 'site-selector-options',
  INSTALL_BUTTON: 'install-button',
  REQUEST_BUTTON: 'request-button',
  REQUEST_ADMIN_SECTION_MSG: 'request-admin-section-msg',
  SITE_SELECTOR_HAMS_MESSAGE: 'site-selector-HAMS-msg'
};